const productEndpoints = {
  accounting: () => '/reporting/products/accounting'
}

export default productEndpoints
